import { createSlice } from '@reduxjs/toolkit';

export const updateHeader = createSlice({
  name: 'updateHeader',
  initialState: {
    data: false,
  },

  reducers: {
    setUpdateHeader: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setUpdateHeader } = updateHeader.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.isLoading`
export const getUpdateHeader = (state) => state.updateHeader.data;

export default updateHeader.reducer;
